import { H4, P, theme } from '@ahmdigital/ui';
import { map, set } from 'lodash/fp';
import Icon from '@ahmdigital/icons-web';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import React from 'react';

import {
  BestSellerTag,
  BestSellerWrapper,
  CardWrapper,
  DetailsWrapper,
  ServiceWrapper,
  StyledAccordionSection,
  StyledButton,
} from './styles';
import { PortableTextType } from '../../../../types/sanityInternal';
import { ServiceType } from '../../../../types/sanity';
import { Slug, UrlObject } from '../../../../types/__codegen__/sanity/graphql';

const { colors } = theme;

type Props = {
  ariaLabel?: string;
  className?: string;
  descriptionRaw?: PortableTextType[];
  identifier: Slug;
  isBestSeller?: boolean;
  index?: number;
  name: string;
  includedServices?: ServiceType[];
  urlObject?: UrlObject;
};

const ItemCard = ({
  ariaLabel,
  className,
  descriptionRaw,
  identifier,
  index,
  isBestSeller,
  name,
  includedServices,
  urlObject,
}: Props) => {
  const formattedServices = map((service) => {
    const { descriptionRaw: serviceDescription, name: title } = service;
    return {
      body: portableTextToPlain(serviceDescription),
      title,
    };
  }, includedServices);

  const itemsWithIcons = map(
    // @ts-ignore - Automatic, Please fix when editing this file
    (item) =>
      set(
        'title',
        <div style={{ display: 'flex', maxWidth: '15rem' }}>
          <div>
            <Icon fill={colors.green} name="tick-circle" />
          </div>
          {item.title}
        </div>,
        item,
      ),
    formattedServices,
  );

  const accordionId = identifier?.current;

  return (
    <CardWrapper className={className} index={index} isBestSeller={isBestSeller} aria-label={ariaLabel}>
      {isBestSeller && (
        <BestSellerWrapper>
          <BestSellerTag variant="simpleBit">Our best seller!</BestSellerTag>
        </BestSellerWrapper>
      )}
      <DetailsWrapper isBestSeller={isBestSeller}>
        <H4 variant="marginBottomSpacer10">{name}</H4>
        <P variant="marginBottomSpacer8">{portableTextToPlain(descriptionRaw)}</P>
        <ServiceWrapper>
          <P variant={['marginBottomSpacer11', 'bold']}>What’s included</P>
          <StyledAccordionSection
            accordionId={`${accordionId}-accordion`}
            // @ts-ignore - Automatic, Please fix when editing this file
            items={itemsWithIcons}
            minimalBorder
            spacerSize="None"
            ariaLabelPrefix={ariaLabel}
          />
        </ServiceWrapper>
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
        {urlObject && <StyledButton to={urlObject.url}>{urlObject.name}</StyledButton>}
      </DetailsWrapper>
    </CardWrapper>
  );
};

export default ItemCard;
